var _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWormup(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 172,
    height: 30,
    viewBox: "0 0 172 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M172 0V20.936L164.157 21.8246V1.27962L172 0ZM172 22.4289V29.1114L164.157 30V23.3175L172 22.4289Z",
    fill: "#CAF201"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M149.244 29.0758L141.402 30V1.27961L147.606 0.106628V1.31516L154.682 0.106628V1.31516L161.792 0.106628V19.4787L149.244 20.9005V29.0758ZM149.244 14.4668L153.95 13.8981V6.61137L149.244 7.14454V14.4668Z",
    fill: "#CAF201"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M116.706 28.1517V1.27962L124.548 0V23.4242L130.3 22.7844V1.27962L138.142 0V25.9123L132.6 26.5166V28.827L122.074 30V27.5829L116.706 28.1517Z",
    fill: "#CAF201"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M87.2063 0V4.12322L91.145 3.66114V8.81517L95.9551 8.24644V3.16351L99.9287 2.70142V1.27962L107.771 0V29.1114L99.9287 30V9.3128L97.5237 9.59716V29.1114L89.6811 30V10.4502L87.2063 10.7346V29.1114L79.3638 30V1.27962L87.2063 0Z",
    fill: "#CAF201"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M64.0762 29.0758L56.2336 30V1.27961L62.438 0.106628V1.31516L69.5137 0.106628V1.31516L76.6243 0.106628V17.346L74.0798 17.6303V21.0071L76.9729 20.6872V28.7204L69.1303 29.6445V22.2156L66.2373 22.5711V18.5189L64.0762 18.7678V29.0758ZM64.0762 12.3341L68.7817 11.7654V6.61137L64.0762 7.14454V12.3341Z",
    fill: "#CAF201"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M32.1164 28.1517V3.76777L38.2162 3.09241V1.13743L47.4181 0.106628V2.48814L53.5876 1.81279V25.9123L48.0107 26.5166V28.827L37.4842 30V27.5829L32.1164 28.1517ZM39.959 23.4242L45.745 22.7844V6.93127L39.959 7.60663V23.4242Z",
    fill: "#CAF201"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M0 22.8199V1.27962L7.84257 0V19.1232L10.8053 18.7678V1.27962L18.6479 0V17.8791L21.6106 17.5237V1.27962L29.4532 0V19.5142L24.2945 20.0829V29.0047L15.8594 30V21.0071L13.5589 21.2559V29.0047L5.12381 30V22.2512L0 22.8199Z",
    fill: "#CAF201"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWormup);
export default __webpack_public_path__ + "static/media/wormup.a5702c4b246adf0a770354b86226cdea.svg";
export { ForwardRef as ReactComponent };